import React from "react";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import Spinner from "../Spinner";
import PropTypes from "prop-types";
import Utils from '../../utils/Utils';
import "./styles.scss";

class TabsWithPanel extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      activeTab: 0,
    };
    this.setActiveTab = this.setActiveTab.bind(this);
  }

  shouldComponentUpdate(nextProps, nextState) {
    return (
      this.state.activeTab !== nextState.activeTab ||
      this.props.isFetching !== nextProps.isFetching
    );
  }

  setActiveTab(tabNumber) {
    this.setState({ activeTab: tabNumber });
  }

  handleMouseEnter = (e) => {
      Utils.handleMouseEnter(e)
  }

  render() {
    const { tabs, children, isFetching, onTabClick, tabSize } = this.props;
    const { activeTab } = this.state;
    const size = tabSize ? tabSize : "large";
    return (
      <div className="playlist-container">
        {isFetching && <Spinner className="spinner-music" />}
        <Tabs
          className="twp"
          selectedIndex={activeTab}
          onSelect={this.setActiveTab}
        >
          <TabList className={`twp-tabs`}>
            {tabs.map((tab, i) => (
              <Tab
                className={`${
                  i === 0 ? "firstTab" : ""
                } twp-tab twp-tab-${size}`}
                key={tab}
              >
                <div className={`twp-tab-name ${activeTab === i ? "twp-tab-selected" : "" }`} >
                  <a
                    id={String(`keyCMR-${Math.floor(10000 + Math.random() * 90000)}`)}
                    className={`focusable`}
                    href="javascript:void(0)"
                    onClick={() => {
                      if (typeof onTabClick === "function") onTabClick(tab);
                      }}
                    onMouseEnter={e => {
                      this.handleMouseEnter(e);
                    }}
                      >
                    {tab}
                  </a>
                </div>
              </Tab>
            ))}
          </TabList>
          <div className="twp-separator-bar" />
          {Array.isArray(children) ? (
            children.map((child, i) => (
              <TabPanel key={i} className={`twp-panel ${activeTab === i ? "active" : ""}`}>
                {child}
              </TabPanel>
            ))
          ) : (
            <TabPanel className="twp-panel">{children}</TabPanel>
          )}
        </Tabs>
      </div>
    );
  }
}

TabsWithPanel.propTypes = {
  isFetching: PropTypes.bool.isRequired,
  tabs: PropTypes.arrayOf(PropTypes.string).isRequired,
  children: PropTypes.element.isRequired,
  onTabClick: PropTypes.func,
  tabSize: PropTypes.arrayOf(["small", "large", "extra-large"]),
};

export default TabsWithPanel;



// WEBPACK FOOTER //
// ./src/components/TabsWithPanel/index.jsx